module.exports = __webpack_public_path__ + "img/wechat-tabs2.92c0b855.png";